export default {
  noBlocks: 'The report contains no blocks yet.',
  addBlock: 'Add block',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  hint: {
    startsOnNewPage: 'Starts on new page',
    templateReplaced: 'Template replaced',
    parametersOnExport: 'Parameters set on export',
    unavailable: 'No longer available',
    onlyFor: 'Only for {scope}',
  },
};
